const INITIAL_STATE = {
  data: {},
  errors: {},

}
const AddFieldOffice = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'ADD_FIELD_OFFICE_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'ADD_FIELD_OFFICE_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default AddFieldOffice;